import React, {Suspense, useState} from 'react';
import {useAuthContext} from "../Auth/provider/AuthProvider";
import {getActiveOrganisation} from "../Auth/services/organisationService";
import RenderIf from "../../core/components/render-if";
import OrganizationCard from "../profile/components/organisation-view/components/organizationCard";
import ProfilePersonJoinToClub from "../profile/person/main/components/join-to-club";
import VerticalBox from "../../core/components/box/vertical";
import Typo from "../../core/components/typo";
import __ from "../../core/utils/translate/translate";
import {MiniLoading} from "../../core/components/loading";
import RootLayout from "../../layout/root";
import {CommonIcon} from "../../core/components/icon";
import {clearTokensAndRedirect} from "../Auth/services/tokenService";
import Button from "../../core/components/button";

export default function GatewayPage(props) {
    const {organisationList} = useAuthContext();
    const activeOrganisation = getActiveOrganisation();
    const [showJoinBox, setShowJoinBox] = useState(organisationList?.length === 0)

    return (
        <>
            <RootLayout haveHumberMenu={false}>
                <div className={'pt-16 pb-4'}>
                    <Suspense fallback={<MiniLoading/>}>
                        <RenderIf cond={organisationList?.length > 0}>
                            <div className={'flex flex-col gap-2'}>
                                {[...organisationList].sort((a, b) =>
                                    (b.id === activeOrganisation?.id) -
                                    (a.id === activeOrganisation?.id))
                                    .map((organisation, index) => (
                                        <OrganizationCard organisation={organisation}
                                                          key={index + ' ' + organisation?.id + 'organizationCard'}/>
                                    ))}
                            </div>
                        </RenderIf>
                        <div className="flex w-full flex-col items-center my-2 p-4 gap-8">
                            <RenderIf cond={showJoinBox} falsyElement={
                                <div className={'p-6'}>
                                    <Button
                                        type="primary"
                                        scale={'fit'}
                                        onClick={() => setShowJoinBox(true)}
                                    >
                                        عضویت در سایر کانون
                                    </Button>
                                </div>
                            }>
                                <ProfilePersonJoinToClub/>
                            </RenderIf>

                        </div>
                        <RenderIf cond={false}>
                            <VerticalBox
                                withBackground
                                className="rounded-b-3xl shadow-[0px_4px_20px_0px_rgba(0,0,0,0.2)]"
                                containerClassName="p-4 px-8"
                            >
                                <div className="flex flex-col gap-1">
                                    <Typo as="p" className="mb-4" type="secondary">
                                        در خواست شما برای عضویت در حال بررسی است
                                    </Typo>
                                    <div className="relative z-[1] flex w-full flex-col p-2">
                                        <Typo weight="semi-bold" className="ui-clamp-3  justify-end">
                                            {__("Are you no longer in this organization?")}
                                        </Typo>
                                        <Typo as="p" className="mb-4" type="secondary">
                                            {__("If you want to change your organization, you must leave this organization first. Be aware that when you leave the organization, you will also leave your team and the points you got in the team will be zero.")}
                                        </Typo>

                                    </div>
                                </div>
                            </VerticalBox>
                        </RenderIf>
                        <div className="flex w-full flex-col items-center my-2 gap-8">
                        <span className="flex gap-2 items-start text-sm h-full transition border-b border-transparent cursor-pointer hover:border-teal-600">
                            <CommonIcon icon={'logout'}></CommonIcon>
                            <div className={'cursor-pointer text-gray-800'}
                                 onClick={clearTokensAndRedirect}>خروج از حساب کاربری</div>
                        </span>
                        </div>
                    </Suspense>
                </div>
            </RootLayout>
        </>
    );
}

